// extracted by mini-css-extract-plugin
export default {"container":"LoadSpinner_container__++nOG","lds-dual-ring":"LoadSpinner_lds-dual-ring__kHisR"};